import React from 'react';
import Icon from '../app_components/Icon';
import { semantic } from '@lexody/design-tokens';
import { iconColorForTone } from './morphismIconColors';
import { usesDashFormVariant } from '../../utils/formVariant';

class DropdownSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdownOpen: false,
      searchText: '',
    };

    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.selectItem = this.selectItem.bind(this);
    this.renderDropdownItems = this.renderDropdownItems.bind(this);
  }

  toggleDropdown() {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  }

  selectItem(item) {
    this.setState({ dropdownOpen: false, searchText: '' });
    this.props.onChange(item[this.props.itemSelector], this.props.attribute);
  }

  renderDropdownItems() {
    const allItems = this.props.items.filter((item) =>
      item[this.props.itemAttribute].toLowerCase().includes(this.state.searchText.toLowerCase())
    );

    if (allItems.length === 0) {
      return (
        <div className="lex-dropdown__item lex-dropdown__item--empty">
          No results
        </div>
      );
    }

    return allItems.map((item, i) => (
      <div
        key={i}
        onClick={() => this.selectItem(item)}
        className="lex-dropdown__item"
        role="option"
      >
        {item[this.props.itemAttribute]}
      </div>
    ));
  }

  render() {
    const { label, value, placeholder, tone = 'grey', icon = 'building', variant } = this.props;
    const displayValue = value || placeholder;
    const isPlaceholder = !value;

    if (usesDashFormVariant(variant)) {
      return (
        <div className={`lex-dash-field lex-dash-field--dropdown lex-dash-field--${tone}`}>
          {label && <label className="lex-dash-field__label">{label}</label>}
          <button
            type="button"
            className="lex-dash-field__selectTrigger"
            onClick={() => this.toggleDropdown()}
          >
            <span className={`lex-dash-field__selectValue${isPlaceholder ? ' lex-dash-field__selectValue--placeholder' : ''}`}>
              {displayValue}
            </span>
            <Icon
              name={this.state.dropdownOpen ? 'angle-up' : 'angle-down'}
              size={16}
              color={semantic.primary.surface.default}
            />
          </button>
          {this.state.dropdownOpen && (
            <div className="lex-dash-dropdown">
              <div className="lex-dropdown__search">
                <Icon name="search" size={16} color={semantic.greyscale.text.caption} />
                <input
                  value={this.state.searchText}
                  onChange={(event) => this.setState({ searchText: event.target.value })}
                  placeholder={`Search ${label}`}
                  onClick={(e) => e.stopPropagation()}
                />
              </div>
              <div className="lex-dropdown__list">
                {this.renderDropdownItems()}
              </div>
            </div>
          )}
        </div>
      );
    }

    return (
      <div className="lex-field lex-dropdown">
        {label && <p className="lex-field__label">{label}</p>}
        <div
          className={`lex-input lex-input--${tone} lex-input--select`}
          onClick={() => this.toggleDropdown()}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.toggleDropdown();
            }
          }}
        >
          <span className="lex-input__icon" aria-hidden="true">
            <Icon name={icon} size={18} color={iconColorForTone(tone)} />
          </span>
          <div className="lex-input__control">
            <span className={`lex-input__value${isPlaceholder ? ' lex-input__value--placeholder' : ''}`}>
              {displayValue}
            </span>
          </div>
          <span className="lex-input__chevron" aria-hidden="true">
            <Icon
              name={this.state.dropdownOpen ? 'angle-up' : 'angle-down'}
              size={18}
              color={semantic.primary.text.label}
            />
          </span>
        </div>
        {this.state.dropdownOpen && (
          <div className="lex-dropdown__panel">
            <div className="lex-dropdown__search">
              <Icon name="search" size={16} color={semantic.greyscale.text.caption} />
              <input
                value={this.state.searchText}
                onChange={(event) => this.setState({ searchText: event.target.value })}
                placeholder={`Search ${label}`}
                onClick={(e) => e.stopPropagation()}
              />
            </div>
            <div className="lex-dropdown__list">
              {this.renderDropdownItems()}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default DropdownSelect;
